import {AbstractInteractionMode, DrawModeOption, DrawStyleUtil} from "./abstract-interaction-mode";
import {
    LocationPickerPointTransformTranslate
} from "../interaction/location-picker/location-picker-point-transform-translate";
import {ViewSimpleSelect} from "../interaction/view/view-simple-select";
import {MapEvent} from "../../document/model/map";
import FormRenderPageModalContainerVue from "../../../pages/documents/FormRenderPageModalContainer.vue";
import MapFormControlVue from "../../../components/map/controls/MapFormControl.vue";
import {VueComponentControl} from "../control/VueComponentControl";
import {LocationPickerTranslatePoint} from "../draw-modes/location-picker/location-picker-translate-point";
import {Feature} from "geojson";
import {TransformInteractionState} from "../interaction/abstract-transform";
import {PinPoint} from "../draw-modes/location-picker/pin-point";

export class BlankMode extends AbstractInteractionMode {
    static identifier: string = "blank";
    static title: string = "Personalizabil";
    static icon: string = "/icons/toolbox/gui-magic.svg";
    static allowPriorityContextMenu: boolean = true;
    static requiresLayer: boolean = false;
    static actionBarSize: 'small' | 'large' | undefined = 'small';
    static actionBarShowLabels = true;
    static drawStyles = DrawStyleUtil.drawStyle({
        "line-color": '#23B402',
        "border-color": '#23B402',
    });

    static defaultInteraction: string = 'select';

    static interactions = {
        'select': ViewSimpleSelect.definition(),
        'point_transform_translate': LocationPickerPointTransformTranslate.definition()
    }

    onInit() {
      super.onInit();
        this.controller.interaction.enableShowHoverInfo()
        this._customButtonSubscriber = (event: {action}) => {
            this.controller.interaction.disableShowHoverInfo()
            switch (event.action?.actionType) {
                case 'open_form_in_modal':
                case 'open_form_in_page':
                    this.controller.hideControls();
                    let control = new VueComponentControl(MapFormControlVue, {...event.action.document, isOpenInModal: true})
                    this.addControl(control, 'top-right');
                    break;
            }
            this.controller.mapInstance.fire(MapEvent.Tick);
        };
        this._mapInstance.on(MapEvent.CustomButtonActioned, this._customButtonSubscriber);
        this._mapInstance.on(MapEvent.PinAdd, (e) => {

            if (!this.currentInteractionState.getFeature()) {
                let feature: Feature = {
                    id: 'temp-id',
                    type: 'Feature',
                    geometry: {type: 'Point', coordinates: []},
                    properties: {id: 'temp-id'},
                };
                let state = new TransformInteractionState([feature], false);
                this.controller.interaction.mode.changeInteraction('point_transform_translate', state)
                this.controller.interaction.mode.add(feature);
            }
        });
        this._mapInstance.on(MapEvent.MapFormAction, (e) => {
            this.removeControls();
            this.controller.showControls();
            //this.controller.interaction.mode.delete(this.currentInteractionState.featureID);
            this.controller.interaction.mode.changeInteraction('select');
            this.controller.interaction.mode.currentInteraction.clearDrawFeatures();
            this.controller.interaction.enableShowHoverInfo()
            this.controller.getLayers().forEach(layer => {
                this.controller.reloadLayer(layer)
            })
            this.controller.mapInstance.fire(MapEvent.Tick);
        });
    }

    onDestroy() {
        this._mapInstance.off(MapEvent.CustomButtonActioned, this._customButtonSubscriber);
        //this._control = undefined;
        super.onDestroy();
    }
}
